import { BOX_BREATHING_PHASES } from '../constants/wellbeingMessages'

/**
 * Box breathing phase helper for SVG ring scale.
 * inhale → expand, hold → stay, exhale → contract, hold → stay
 */
export function getPhaseScale(phaseId) {
	switch (phaseId) {
		case 'inhale':
			return 1.22
		case 'hold_in':
			return 1.22
		case 'exhale':
			return 0.78
		case 'hold_out':
			return 0.78
		default:
			return 1
	}
}

export function getPhaseAt(index) {
	const safe = ((index % BOX_BREATHING_PHASES.length) + BOX_BREATHING_PHASES.length) %
		BOX_BREATHING_PHASES.length
	return BOX_BREATHING_PHASES[safe]
}

export function nextPhaseIndex(index) {
	return (index + 1) % BOX_BREATHING_PHASES.length
}
